
<nav class="header__navbar">
  <div class="navbar-container">
    <div class="navbar-logo">
      <img 
        src="../../../../assets/logo/logo-app.png" width="150%"
        class="header__logo" alt="Logo">
    </div>
<div class="navbar-spacer"></div>
<div class="language-switcher" [class.open]="isLanguageMenuOpen">
<button class="language-current" (click)="toggleLanguageMenu()">
        <img [src]="getCurrentLanguageFlag()" 
             [alt]="getCurrentLanguageName()" 
             class="flag-current">
      </button>
<div class="language-dropdown" *ngIf="isLanguageMenuOpen">
        <button class="language-option" 
                (click)="switchLanguage('vi')"
                [class.selected]="currentLanguage === 'vi'">
          <img src="https://flagcdn.com/24x18/vn.png" alt="Tiếng Việt" class="flag-option">
          <span class="lang-name">VI</span>
        </button>
        <button class="language-option" 
                (click)="switchLanguage('en')"
                [class.selected]="currentLanguage === 'en'">
          <img src="https://flagcdn.com/24x18/us.png" alt="English" class="flag-option">
          <span class="lang-name">EN</span>
        </button>
        <button class="language-option" 
                (click)="switchLanguage('zh')"
                [class.selected]="currentLanguage === 'zh'">
          <img src="https://flagcdn.com/24x18/cn.png" alt="中文" class="flag-option">
          <span class="lang-name">中文</span>
        </button>
        <button class="language-option" 
                (click)="switchLanguage('fr')"
                [class.selected]="currentLanguage === 'fr'">
          <img src="https://flagcdn.com/24x18/fr.png" alt="Français" class="flag-option">
          <span class="lang-name">FR</span>
        </button>
      </div>
    </div>
<div class="navbar-user" (click)="toggleUserMenu()">
      <div class="user-avatar">
        <img [src]="avatarUrl" alt="User Avatar">
      </div>
      <div class="user-info">
        <span class="user-name">{{ username || 'Admin User' }}</span>
        <span class="user-role">{{ userRole || 'Administrator' }}</span>
      </div>
      <div class="user-menu" [class.active]="isUserMenuOpen">
        <div class="menu-item" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'NAVBAR.LOGOUT' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</nav>